const getMyCompany = (state) => state.myCompany.data
const getMyCompanyState = (state) => state.myCompany

export default {
  getMyCompany,
  getMyCompanyState
}
